import { EventEmitter, Injectable } from "@angular/core";
import { TipoLayout } from "../../../enums/tipo-layout.enum";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GridPreCargasService {

  alteracaoConfigGridPreCargaEvent = new EventEmitter<any[]>();
  alteracaoConfigGridCarregamentosGravadosEvent = new EventEmitter<any[]>();
  alterouConfiguracaoGridPreCargasEvent = new EventEmitter<any>();
  alterouConfiguracaoGridCarregamentosGravadosEvent = new EventEmitter<any>();
  alterouConfiguracaoGridPedidosEvent = new EventEmitter<any>();
  public alterouLayout = new BehaviorSubject<TipoLayout>(localStorage.getItem('layout') as TipoLayout || TipoLayout.REDUZIDO);
  toggleGridOpen = new EventEmitter<boolean>();

  constructor() {}
}
